var mentions_default = {
  "mention": "MGbdr",
  "mentionViewer": "tE1Cq",
  "cursorDefault": "Q98w4",
  "cursorPointer": "EteFn"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
